/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { LuUser } from "react-icons/lu";
import { MyContext } from "../Context/MyProvider";
import Login from "./Login";
import Signup from "./Signup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import Callicon from "../assets/Icon/phone-blue.svg";
import Mailicon from "../assets/Icon/mail-blue.svg";
import { useTranslation } from "react-i18next";
import "react-phone-number-input/style.css";
import { showToast } from "../showTost";
import Logo from "../assets/Image/Logo.png";
import Loading from "./Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "./ImageLoad";

const Header = () => {
  const {
    ApiBaseUrl,
    ImgBaseUrl,
    isLoginShow,
    setMedicineId,
    setIsLoginShow,
    setIsLogin,
    setSelectProduct,
    isSignUpShow,
    setIsSignUpShow,
    isLogin,
    setIsFooter,
    setActivePage,
    isShow,
    setIsShow,
  } = useContext(MyContext);

  const { t, i18n } = useTranslation();

  const [userImg, setUserImg] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isShowImg, setIsShowImg] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [input, setInput] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [selectlag, setSelectLag] = useState("en");
  const [apiloading, setApiLoading] = useState(false);
  const [searchstorelist, setSearchStoreList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [showMenu, setShowMenu] = useState(false);

  const Language = [
    { id: "en", title: "English" },
    { id: "ar", title: "عربي" },
    { id: "hi", title: "Hindi" },
    { id: "sp", title: "Spanish" },
    { id: "fr", title: "French" },
    { id: "ge", title: "Germany" },
    { id: "in", title: "Indonesia" },
    { id: "sa", title: "South Africa" },
    { id: "tu", title: "Turkish" },
    { id: "po", title: "Portuguese" },
  ];

  const Navigate = useNavigate();
  const location = useLocation();

  const isStorePage = location.pathname.includes("store-home")
    ? 1
    : location.pathname.includes("/shop-list")
      ? 3
      : location.pathname.includes("/shop")
        ? 2
        : 4;

  const NoMoreDataRef = useRef(true);
  const Currency = secureLocalStorage.getItem("currency");

  useEffect(() => {
    const Loginuser = secureLocalStorage.getItem("Loginuser");
    if (Loginuser) {
      const { image, name, email } = JSON.parse(Loginuser);
      setName(name);
      setEmail(email);
      setUserImg(image);
      setIsShowImg(true);
    } else {
      setUserImg("");
      setIsShowImg(false);
    }
  }, [isLogin]);

  useEffect(() => {
    if (!input) {
      setSearchShow(false);
      return;
    }

    setSearchShow(true);
    setApiLoading(true);
    setPage(1);
    NoMoreDataRef.current = true;

    if (isStorePage === 1) {
      HandleStoreSerch(input, 1);
    } else if (isStorePage === 2) {
      hadnleSearchMedicine(input, 1);
    } else if (isStorePage === 3) {
      hadnleSearchMedicine(input, 2);
    } else {
      setPage(1);
      HandleDoctorSearch(input, 1);
    }
  }, [input]);

  const HandleDoctorSearch = (inputText, currentPage) => {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = String(position.coords.latitude);
      const long = String(position.coords.longitude);

      axios
        .post(`${ApiBaseUrl}/customer/search_doctor`, {
          text: inputText,
          lat: lat,
          lon: long,
          page: currentPage,
        })
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            const newDoctors = res.data.doctor_list;
            if (newDoctors.length === 0) NoMoreDataRef.current = false;
            setSearchData((prev) =>
              currentPage === 1 ? newDoctors : [...prev, ...newDoctors],
            );
            setHasMore(true);
          }
          setApiLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  };

  const HandleStoreSerch = (input, page) => {
    const LocalData = sessionStorage.getItem("Docdetails");
    if (LocalData) {
      const { Docid } = JSON.parse(LocalData);
      const Userid = secureLocalStorage.getItem("Userid");
      axios
        .post(`${ApiBaseUrl}/customer/product_search`, {
          uid: Userid,
          search_field: input,
          doctor_id: Docid,
          page,
        })
        .then((res) => {
          const { ResponseCode, product_list } = res.data;
          if (ResponseCode === 200) {
            if (product_list.length === 0) NoMoreDataRef.current = false;
            setApiLoading(false);
            setSearchStoreList(product_list);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const hadnleSearchMedicine = (input, index) => {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = String(position.coords.latitude);
      const long = String(position.coords.longitude);

      axios
        .post(`${ApiBaseUrl}/customer/store-search`, {
          serchtext: input,
          user_lat: lat,
          user_lon: long,
          type: index === 1 ? "medi" : "store",
        })
        .then((res) => {
          console.log("customer/store-search", res);
          const ResDataList =
            index === 1 ? res.data.productList : res.data.store;
          setSearchData(ResDataList);
          setApiLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop > lastScrollTop) {
      if (
        scrollTop + clientHeight >= scrollHeight - 10 &&
        hasMore &&
        NoMoreDataRef.current
      ) {
        setHasMore(false);
        setPage((prev) => prev + 1);
      }
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef) return;
    HandleDoctorSearch(input, page);
  }, [page]);

  const HandleNavigate = (index) => {
    if (index === 0) {
      setActivePage(0);
      Navigate("/");
      setIsFooter(false);
    } else {
      if (window.innerWidth > 1025) {
        setActivePage(1);
        Navigate("/dashbord/booking");
      } else {
        setActivePage(0);
        Navigate("/");
      }
    }
  };

  useEffect(() => {
    const lang = secureLocalStorage.getItem("I18");

    if (lang) {
      setSelectLag(lang);
    }
  }, []);

  const HandleNavigateDoc = (e, title, Id, departmentid) => {
    e.stopPropagation();
    Navigate(`/doctor-profile/${departmentid}/${Id}`);
    sessionStorage.setItem(
      "Docprofile",
      JSON.stringify({ title: title, path: "/", pagename: "Home" }),
    );
    setSearchShow(false);
    setInput("");
  };

  const changeLanguage = (lang) => {
    setSelectLag(lang);
    i18n.changeLanguage(lang);
    secureLocalStorage.setItem("I18", lang);
    setIsShow(false);
  };

  const HandleSelectStore = (id) => {
    setSelectProduct(id);
    setSearchShow(false);
    setInput("");
  };

  const HandleNavigateLab = (item) => {
    setSearchShow(false);
    setInput("");
    Navigate("/store-home");
    const Categoreyid = sessionStorage.getItem("Catid");
    sessionStorage.setItem(
      "Docdetails",
      JSON.stringify({ Docid: item.id, Categoreyid }),
    );
  };

  const HandleLogOut = () => {
    const Loginuser = secureLocalStorage.getItem("Loginuser");
    if (Loginuser) {
      showToast({ title: t("Logout Successful!"), id: "success" });
      Navigate("/");
      setIsLogin("1");
      secureLocalStorage.clear();
      sessionStorage.clear();
    }
  };

  return (
    <div className="left-0 right-0 sticky top-[10px] z-[999] mx-[20px]">
      <div className="header width-container">
        <div className="logo-box">
          <img
            onClick={() => HandleNavigate(0)}
            src={Logo}
            className="w-[50px] cursor-pointer"
            alt="Logo"
          />
          <button
            className="max-_1025_:hidden"
            onClick={() => HandleNavigate(0)}
          >
            <h3>Doctorrhynor</h3>
          </button>
        </div>

        <div className="info-box">
          <div className="search-box relative">
            <RiSearchLine className="icon" />
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="text-[16px]"
              placeholder={
                isStorePage == 1
                  ? t("Search Hevan Medical Store Product")
                  : isStorePage == 2
                    ? t("Search by medicine name")
                    : isStorePage === 3
                      ? t("Search by store")
                      : t("Search Doctor")
              }
            />

            {input && searchShow && (
              <div
                onScroll={handleScroll}
                style={{ boxShadow: "rgb(0 0 0 / 36%) 0px 0px 10px 0px" }}
                className="w-[100%] max-h-[500px] absolute bg-[#F6F7F8] px-[10px] py-[5px] top-[65px] rounded-[10px] scroll-container z-[888]"
              >
                {apiloading ? (
                  <Loading CustomeStyle="w-full h-[480px] rounded-[10px] bg-white flex items-center justify-center" />
                ) : (
                  <div className="">
                    {isStorePage === 1 ? (
                      <div>
                        {searchstorelist.length >= 1 ? (
                          searchstorelist.map((item, index) => {
                            return (
                              <div
                                key={index}
                                onClick={() => HandleSelectStore(item.id)}
                                className="bg-white py-[8px] px-[10px] rounded-[10px] overflow-hidden cursor-pointer mt-[5px]"
                              >
                                <div className="flex items-center gap-[10px]">
                                  <ImageLoad
                                    src={ImgBaseUrl + item.product_image}
                                    CustomeStyle={
                                      "w-[70px] rounded-[10px] object-cover"
                                    }
                                    alt={"product_image"}
                                  />
                                  <div className="w-[80%]">
                                    <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.product_name}
                                    </h1>
                                    <div className="flex items-center gap-[10px]">
                                      <h1 className="font-bold">
                                        {Currency}
                                        {item.price_detail[0].price}
                                      </h1>
                                      <span className="line-through">
                                        {Currency}
                                        {item.price_detail[0].base_price}
                                      </span>
                                      <div className="bg-yellow-500 px-[8px] rounded-[50px]">
                                        <p className="font-[500] text-white text-[14px]">
                                          {item.price_detail[0].discount}%{" "}
                                          {t("OFF")}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center py-[20px]'">
                            <div className="text-center">
                              <h1 className="font-[500] text-[18px]">
                                {t("No product yet!")}
                              </h1>
                              <p className="text-gray-600">
                                {t("Currently you don't have any")} <br />{" "}
                                {t("product in you area!.")}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : isStorePage === 2 ? (
                      <div>
                        {searchData.length >= 1 ? (
                          searchData.map((item, index) => {
                            return (
                              <div
                                key={index}
                                onClick={() => {
                                  setMedicineId(item);
                                  setSearchShow(false);
                                  setInput("");
                                }}
                                className="bg-gray-100 py-[8px] px-[10px] rounded-[10px] overflow-hidden cursor-pointer mt-[5px]"
                              >
                                <div className="flex items-center gap-[10px]">
                                  <ImageLoad
                                    src={ImgBaseUrl + item.product_image}
                                    CustomeStyle={
                                      "w-[70px] h-[70px] rounded-[10px] object-cover"
                                    }
                                    alt={"product_image"}
                                  />
                                  <div className="w-[80%] leading-5">
                                    <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.product_name}
                                    </h1>
                                    <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.shop_name}
                                    </h1>
                                    <div className="flex items-center gap-[10px]">
                                      <h1 className="font-bold">
                                        {Currency}
                                        {item.price_detail.price}
                                      </h1>
                                      <span className="line-through">
                                        {Currency}
                                        {item.price_detail.base_price}
                                      </span>
                                      <div className="bg-yellow-500 px-[8px] rounded-[50px]">
                                        <p className="font-[500] text-white text-[14px]">
                                          {item.price_detail.discount}%{" "}
                                          {t("OFF")}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center text-center py-[20px]">
                            <div className="text-center">
                              <h1 className="font-[500] text-[18px]">
                                {t("No Medicine yet!")}
                              </h1>
                              <p className="text-gray-600 leading-5">
                                {t("Currently you don't have any")} <br />{" "}
                                {t("Medicine in you area!.")}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : isStorePage === 3 ? (
                      <div>
                        {searchData.length >= 1 ? (
                          searchData.map((item, index) => {
                            return (
                              <div
                                key={index}
                                onClick={() => HandleNavigateLab(item)}
                                className="bg-gray-100 py-[8px] px-[10px] rounded-[10px] overflow-hidden cursor-pointer mt-[5px]"
                              >
                                <div className="flex items-center gap-[10px]">
                                  <ImageLoad
                                    src={ImgBaseUrl + item.shop_image}
                                    CustomeStyle={
                                      "w-[70px] h-[70px] rounded-[10px] object-cover"
                                    }
                                    alt={"shop_image"}
                                  />
                                  <div className="w-[80%] leading-5">
                                    <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.shop_name}
                                    </h1>
                                    <p className="whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.address}
                                    </p>
                                    <div className="flex items-center gap-[10px] justify-between">
                                      <h1 className="flex items-center gap-[5px] font-[500]">
                                        <FaStar className="text-orange-400 text-[17px]" />
                                        {item.avg_star}{" "}
                                        <span className="text-gray-500">
                                          ({item.tot_review})
                                        </span>{" "}
                                      </h1>
                                      <h1 className="flex items-center gap-[5px] font-[500]">
                                        <svg
                                          width="15"
                                          height="15"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http:www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                                            fill="black"
                                          />
                                        </svg>
                                        {item.distance} KM
                                      </h1>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center text-center py-[20px]">
                            <div className="text-center">
                              <h1 className="font-[500] text-[18px]">
                                {t("No Store yet!")}
                              </h1>
                              <p className="text-gray-600 leading-5">
                                {t("Currently you don't have any")} <br />{" "}
                                {t("Store in you area!.")}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        {searchData.length >= 1 ? (
                          searchData.map((item, index) => {
                            return (
                              <div
                                onClick={(e) =>
                                  HandleNavigateDoc(e, item.name, item.id, "0")
                                }
                                key={index}
                                className="bg-white py-[8px] px-[10px] rounded-[10px] cursor-pointer mt-[5px]"
                              >
                                <div className="flex items-center gap-[10px]">
                                  <ImageLoad
                                    src={ImgBaseUrl + item.logo}
                                    CustomeStyle={
                                      "max-w-[70px] min-w-[70px] h-[70px] rounded-[10px] object-cover border-[1px]"
                                    }
                                    alt={"logo"}
                                  />
                                  <div className="leading-[20px] w-[100%] overflow-hidden">
                                    <h1 className="font-[500] text-[17px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.name}
                                    </h1>
                                    <p className="whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.title}
                                    </p>
                                    <p className="whitespace-nowrap overflow-hidden overflow-ellipsis">
                                      {item.subtitle}
                                    </p>
                                  </div>
                                </div>
                                <div className="mt-[5px] flex items-center gap-[10px] justify-between">
                                  {item.tot_favorite === 1 && (
                                    <h1>💙 {t("1 Love this")}</h1>
                                  )}
                                  <h1 className="flex items-center gap-[5px]">
                                    <svg
                                      width="15"
                                      height="15"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                                        fill="black"
                                      />
                                    </svg>
                                    {item.distance}
                                  </h1>
                                  <h1 className="flex items-center gap-[5px]">
                                    <FaStar className="text-orange-400" />{" "}
                                    {item.avg_star} {t("Reviews")}
                                  </h1>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center text-center py-[20px]">
                            <div className="text-center">
                              <h1 className="font-[500] text-[18px]">
                                {t("No Doctor yet!")}
                              </h1>
                              <p className="text-gray-600 leading-5">
                                {t("Currently you don't have any")} <br />{" "}
                                {t("doctor in you area!.")}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="call-box">
            <img src={Callicon} alt="CallIcon" />
            <div className="leading-5 text-[15px]">
              <span className="text-gray-600">{t("Emergency Line")}</span>
              <h5 className="text-blue-900 font-[500]">+91 91561 00600</h5>
            </div>
          </div>
          <div className="email-box">
            <img src={Mailicon} alt="EmailIcon" />
            <div className="leading-5 text-[15px]">
              <span className="text-gray-600">{t("Support Email")}</span>
              <h5 className="text-blue-900 font-[500]">
                support@doctorrhynor.com
              </h5>
            </div>
          </div>
          <div className="">
            {isShowImg ? (
              <div className="relative">
                <div
                  onClick={() => setShowMenu(true)}
                  className="flex items-center gap-1 cursor-pointer"
                >
                  <div className="w-[40px] h-[40px] rounded-[100%] overflow-hidden">
                    {userImg ? (
                      <ImageLoad
                        src={ImgBaseUrl + userImg}
                        CustomeStyle={"w-[100%] h-[100%] object-cover"}
                        alt={"logo"}
                        index={1}
                      />
                    ) : (
                      <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[20px]">
                        <span className="-mt-[6px]">{name?.split("")[0]}</span>
                      </div>
                    )}
                  </div>
                  <svg
                    width="24"
                    height="24"
                    className={`${showMenu ? "rotate-180" : "rotate-0"} duration-200`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z"
                      fill="#25314C"
                    />
                  </svg>
                </div>

                {showMenu && (
                  <div className="absolute top-[70px] -left-[165px] z-[888]">
                    <div className="menu_box">
                      <div className="px-4 py-4 bg-blue-50 border-b border-gray-100">
                        <div className="flex items-center gap-[10px]">
                          <div className="max-w-[40px] min-w-[40px] h-[40px]">
                            {userImg ? (
                              <ImageLoad
                                src={ImgBaseUrl + userImg}
                                CustomeStyle={
                                  "w-[100%] h-[100%] object-cover rounded-full"
                                }
                                alt={"logo"}
                                index={1}
                              />
                            ) : (
                              <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[20px]">
                                <span className="-mt-[6px]">
                                  {name?.split("")[0]}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="leading-5 overflow-hidden">
                            <p className="font-bold text-gray-900 text-[17px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                              {name}
                            </p>
                            <p className="text-[14px] text-gray-600 whitespace-nowrap overflow-hidden overflow-ellipsis">
                              {email}
                            </p>
                          </div>
                        </div>
                      </div>

                      <Link
                        to="/dashbord"
                        onClick={() => setShowMenu(false)}
                        className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group"
                      >
                        <div className="text-blue-600 group-hover:bg-blue-100 p-[8px] rounded-[10px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </div>
                        <span className="font-medium text-gray-700 group-hover:text-gray-900">
                          {t("Dashboard")}
                        </span>
                      </Link>

                      <Link
                        to="/profile"
                        onClick={() => setShowMenu(false)}
                        className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group"
                      >
                        <div className="text-purple-600 group-hover:bg-purple-100 p-[8px] rounded-[10px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                        </div>
                        <span className="font-medium text-gray-700 group-hover:text-gray-900">
                          {t("My Profile")}
                        </span>
                      </Link>

                      <div
                        onClick={() => {
                          setIsShow(true);
                          setShowMenu(false);
                        }}
                        className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group"
                      >
                        <div className="text-lime-600 group-hover:bg-lime-100 p-[8px] rounded-[10px]">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 10.3431 17.5228 9 12 9C6.47715 9 2 10.3431 2 12M22 12C22 13.6569 17.5228 15 12 15C6.47715 15 2 13.6569 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2"
                              stroke="currentColor"
                              strokeWidth="1.5"
                            />
                          </svg>
                        </div>
                        <span className="font-medium text-gray-700 group-hover:text-gray-900">
                          {t("Language")}
                        </span>
                      </div>

                      <div
                        onClick={HandleLogOut}
                        className="px-4 py-3 flex items-center gap-[20px] cursor-pointer group hover:bg-red-50"
                      >
                        <div className="text-red-600 group-hover:bg-red-100 p-[8px] rounded-[10px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="m16 17 5-5-5-5"></path>
                            <path d="M21 12H9"></path>
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                          </svg>
                        </div>
                        <span className="font-medium text-red-600">
                          {t("Logout")}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <button
                onClick={() => setIsLoginShow(true)}
                className="login-btn"
              >
                <LuUser />
                <h4 className="font-[500]">{t("Login")}</h4>
              </button>
            )}
          </div>
        </div>
      </div>

      {isLoginShow && (
        <div
          onClick={() => setIsLoginShow(false)}
          className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]"
        >
          <div onClick={(e) => e.stopPropagation()} className="model">
            <Login />
          </div>
        </div>
      )}

      {isSignUpShow && (
        <div
          onClick={() => setIsSignUpShow(false)}
          className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]"
        >
          <div onClick={(e) => e.stopPropagation()} className="model">
            <Signup />
          </div>
        </div>
      )}

      {searchShow && (
        <div
          onClick={() => {
            setSearchShow(false);
            setInput("");
          }}
          className="overlay"
        ></div>
      )}

      {showMenu && (
        <div onClick={() => setShowMenu(false)} className="overlay"></div>
      )}

      {isShow && (
        <div
          onClick={() => setIsShow("")}
          className="flex bg-black/40 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-in fade-in duration-200"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[80vh] overflow-hidden animate-in slide-in-from-bottom-4 duration-300"
          >
            <div className="px-6 py-5 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">
                  Select Language
                </h2>
                <button
                  onClick={() => setIsShow("")}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                >
                  <svg
                    className="w-5 h-5 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="px-4 py-3 max-h-[calc(80vh-100px)] overflow-y-auto">
              {Language.map((item, index) => (
                <div
                  key={index}
                  onClick={() => changeLanguage(item.id, index)}
                  className={`
            relative cursor-pointer rounded-xl p-4 mb-2 transition-all duration-200
            ${
              selectlag === item.id
                ? "bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-[--button-color] shadow-sm"
                : "bg-gray-50 border-2 border-transparent hover:border-gray-200 hover:bg-gray-100"
            }
          `}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div
                        className={`
                w-10 h-10 rounded-full flex items-center justify-center text-lg font-semibold
                ${
                  selectlag === item.id
                    ? "bg-[--button-color] text-white"
                    : "bg-white text-gray-600 border-2 border-gray-200"
                }
                transition-all duration-200
              `}
                      >
                        {item.title.charAt(0).toUpperCase()}
                      </div>
                      <h3
                        className={`
                font-medium text-base
                ${selectlag === item.id ? "text-gray-900" : "text-gray-700"}
              `}
                      >
                        {item.title}
                      </h3>
                    </div>

                    <div className="relative w-6 h-6">
                      <div
                        className={`
                w-6 h-6 rounded-full flex items-center justify-center transition-all duration-200
                ${
                  selectlag === item.id
                    ? "border-2 border-[--button-color] bg-white"
                    : "border-2 border-gray-300 bg-white"
                }
              `}
                      >
                        <span
                          className={`
                  w-3 h-3 rounded-full transition-all duration-200
                  ${
                    selectlag === item.id
                      ? "bg-[--button-color] scale-100"
                      : "bg-transparent scale-0"
                  }
                `}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
/* jshint ignore:end */
